/* eslint-disable */

<template>
  <main class="cv">
    <div class="speech-bubble  speech-bubble--margin">
      hello
    </div>
    <div class="cv__secondary">
      <div class="cv__intro  hidden-lg">
        <p class="cv__copy">
          I’m a talented designer with lots of strings to my bow. I’ve got a wealth of experience designing and managing within the print industry and for the past few years I’ve moved my skills across to the world of UX/UI and web development. Web development is a constant learning curve (I enjoy picking up new skills) but right now I’m proficient in HTML, CSS, JavaScript & many more whilst specialising in web performance.
        </p>
        <p class="cv__copy">
          When it comes to design style I like to think I’m pretty skilled at infusing disparate elements from lots of different genres and making them work in a clean and classic way.
        </p>
        <p class="cv__copy">
          Right now I’m working in-house for Blinds 2go, a multi-million-pound e-commerce business, as a UX/UI Developer / Designer. That’s alongside my freelance projects that I complete in my spare time. As such, it goes without saying that I know all about the pressure of deadlines, the importance of good working relationships and how to deal with clients.
        </p>
      </div>
      <div class="cv__section">
        <h2 class="cv__heading">Skills</h2>
        <h3 class="cv__subheading">Design</h3>

        <p class="cv__copy">UX/UI</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--90"></div>
        </div>

        <p class="cv__copy">Adobe Photoshop</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--90"></div>
        </div>

        <p class="cv__copy">Adobe Illustrator</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--90"></div>
        </div>

        <p class="cv__copy">Adobe InDesign</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--70"></div>
        </div>

        <p class="cv__copy">Adobe Xd</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--80"></div>
        </div>

        <p class="cv__copy">Quark Express</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--70"></div>
        </div>

        <!-- <p class="cv__copy">Microsoft Office</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--70"></div>
        </div> -->

        <p class="cv__copy">Photography</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--60"></div>
        </div>

        <h3 class="cv__subheading">Web Development</h3>

        <p class="cv__copy">HTML5</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--85"></div>
        </div>

        <p class="cv__copy">CSS3 / SCSS</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--85"></div>
        </div>

        <p class="cv__copy">JS / JQuery</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--60"></div>
        </div>

        <p class="cv__copy">Web Speed / Performance Optimisations</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--90"></div>
        </div>

        <p class="cv__copy">Vue JS</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--40"></div>
        </div>

        <p class="cv__copy">WordPress</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--70"></div>
        </div>

        <!-- <p class="cv__copy">npm / CLI</p>
        <div class="cv__skill">
          <div class="cv__level  cv__level--60"></div>
        </div> -->

      </div>
      <div class="cv__section">
        <h2 class="cv__heading">Interests</h2>
        <img src="../assets/site-icons/fitness-icon.svg" alt="black and white icon of a dumbbell referring to a love of fitness" class="cv__icon" />
        <img src="../assets/site-icons/gaming-icon.svg" alt="black and white icon of a gaming pad referring to the love of gaming" class="cv__icon" />
        <img src="../assets/site-icons/reading-icon.svg" alt="black and white icon of a book referring to the love of reading" class="cv__icon" />
        <img src="../assets/site-icons/movie-icon.svg" alt="black and white icon of a movie clipper referring to a love of movies" class="cv__icon" />
        <img src="../assets/site-icons/youtube-icon.svg" alt="black and white icon of youtube referring to a love of watching youtube videos" class="cv__icon" />
        <img src="../assets/site-icons/travel-icon.svg" alt="black and white icon of a plane flying over the world referring to a love of travelling" class="cv__icon" />
        <img src="../assets/site-icons/art-icon.svg" alt="black and white icon of a pencil referring to a love of art and drawing" class="cv__icon" />
        <br />
        <br />
        <br />
        <br />
        <h2 class="cv__heading">Opportunities</h2>
        <p class="cv__copy">
          I’m always interested in new and exciting opportunities so if you have any to share the best way to grab me is at <a href="mailto:hello@mjccreative.me" class="cv__link">hello@mjccreative.me</a>.
        </p>
      </div>
    </div>
    <!-- ends secondary -->
    <div class="cv__main">
      <div class="cv__intro  hidden-sm">
        <p class="cv__copy">
          I’m a talented designer with lots of strings to my bow. I’ve got a wealth of experience designing and managing within the print industry and for the past few years I’ve moved my skills across to the world of UX/UI and web development. Web development is a constant learning curve (I enjoy picking up new skills) but right now I’m proficient in HTML, CSS, JavaScript & many more whilst specialising in web performance.
        </p>
        <p class="cv__copy">
          When it comes to design style I like to think I’m pretty skilled at infusing disparate elements from lots of different genres and making them work in a clean and classic way.
        </p>
        <p class="cv__copy">
          Right now I’m working in-house for Blinds 2go, a multi-million-pound e-commerce business, as a UX/UI Developer / Designer. That’s alongside my freelance projects that I complete in my spare time. As such, it goes without saying that I know all about the pressure of deadlines, the importance of good working relationships and how to deal with clients.
        </p>
      </div>
      <div class="cv__experience">
        <h2 class="cv__heading">Experience</h2>

        <h3 class="cv__subheading">
          Senior UX/UI Developer / Designer @ Blinds 2go Group
        </h3>
        <p class="cv__date">2020 - Present</p>

        <h3 class="cv__subheading">UX/UI & Development:</h3>
        <ul>
          <li class="cv__copy">
            Liaising with international partners and sister site directors along with giving technical support.
          </li>
          <li class="cv__copy">
            Building, deploying and maintaining international sites on a daily basis.
          </li>
          <li class="cv__copy">
            Supporting junior developers through home and international projects.
          </li>
        </ul>
        <i class="cv__copy">In addition to the below;</i>

        <h3 class="cv__subheading">
          UX/UI Developer / Designer @ Blinds 2go Group
        </h3>
        <p class="cv__date">2015 - 2020</p>

        <h3 class="cv__subheading">UX/UI / Design:</h3>
        <ul>
          <li class="cv__copy">
            Producing concepts and graphics including newsletters for offers and
            sales.
          </li>
          <li class="cv__copy">
            Artwork for magazines, newspaper advertising as well as stationary
            for all companies.
          </li>
          <li class="cv__copy">
            Marketing and advertising for TV commercials and product videos.
          </li>
          <li class="cv__copy">
            Consulting with in house textile printers located in Vietnam.
          </li>
          <li class="cv__copy">
            Production of corporate guidelines for all brands in our group.
          </li>
          <li class="cv__copy">
            Rebranding and redesigning all sites and creating new websites in accordance with the corporate guidelines including wire framing and UI / UX interfaces.
          </li>
          <li class="cv__copy">
            Maintaining consistency throughout the newly designed brands.
          </li>
          <li class="cv__copy">
            Creating new room sets and product images for the site.
          </li>
          <li class="cv__copy">
            Working under pressure and to tight deadlines with a large workload.
          </li>
        </ul>

        <h3 class="cv__subheading">Web Development:</h3>
        <ul>
          <li class="cv__copy">
            Performance / speed enhancements and maintaining of code for all sites including work on new features.
          </li>
          <li class="cv__copy">
            Working with backend developers to create in house web applications to be used internally for product managements and offer setups.
          </li>
          <li class="cv__copy">
            Implementing new techniques such as SVGs and SCSS.
          </li>
          <li class="cv__copy">
            Working within a close-knit team of data-analysts, copywriters and textile designers to continue and increase the success of the company.
          </li>
          <li class="cv__copy">
            Creating Google display adverts using Google Web Designer.
          </li>
          <li class="cv__copy">
            Problem solving during a period of exceptional growth within the company whilst working with a constantly changing development environment.
          </li>
          <li class="cv__copy">
            Maintaining and updating our company blog using WordPress.
          </li>
          <li class="cv__copy">
            Working within a agile development environment.
          </li>
        </ul>

        <h3 class="cv__subheading">Studio Manager / Graphic Designer @ Copyright Print Services</h3>
        <p class="cv__date">2007 - 2015</p>

        <h3 class="cv__subheading">Design:</h3>
        <ul>
          <li class="cv__copy">Pre-press / graphic design for both litho & digital print applications including amending customer’s artwork over a variety of mediums including web.</li>
          <li class="cv__copy">Meeting with customers and working from briefs to tight deadlines.</li>
          <li class="cv__copy">Designing using variable data to achieve a personalised end product.</li>
        </ul>

        <h3 class="cv__subheading">Print:</h3>
        <ul>
          <li class="cv__copy">Press operator for a Xiekon 500, Xerox DC250, HP 6-colour Inkjet.</li>
          <li class="cv__copy">Producing and fitting exhibition style displays using mounting, laminating and encapsulation equipment.</li>
          <li class="cv__copy">Print finishing including creasing, binding and guillotining which becomes extremely useful when designing complex artwork for a professional finish.</li>
        </ul>

        <h3 class="cv__subheading">Management:</h3>
        <ul>
          <li class="cv__copy">Managing projects independently including interacting with other print companies and sourcing services and materials.</li>
          <li class="cv__copy">Managing a small team of employees, making sure jobs are completed to tight deadlines and to a high standard whilst advising on economical ways of quoting future work. This is accomplished while progressing with my own projects.</li>
          <li class="cv__copy">Finally my main role was to take over of all aspects of production from the Director as they focused on pushing the company forward.</li>
        </ul>








        <h3 class="cv__subheading">Graphic Designer @ mjccreative</h3>
        <p class="cv__date">2007 - Present</p>
        <p class="cv__copy">
          Working with a vast array of clients throughout many industries
          providing graphic and web design services along with front-end web
          development.
        </p>
      </div>
      <div class="cv__education">
        <div class="cv__section">
          <h2 class="cv__heading">Education</h2>

          <h3 class="cv__subheading">Learn JavaScript: Intermediate & Asynchronous</h3>
          <p class="cv__date">2021</p>
          <p class="cv__copy">Codecademy</p>

          <h3 class="cv__subheading">The Ultimate Character Design Course, <br/> The Ultimate Digital Painting Course</h3>
          <p class="cv__date">2020</p>
          <p class="cv__copy">Udemy</p>

          <h3 class="cv__subheading">The Progressive Web: Building For Resilience Workshop</h3>
          <p class="cv__date">2019</p>
          <p class="cv__copy">Jeremy Keith - adactio</p>

          <h3 class="cv__subheading">Performance Matters Course</h3>
          <p class="cv__date">2017</p>
          <p class="cv__copy">Harry Roberts - CSS Wizardry</p>

          <h3 class="cv__subheading">Digital Photography Level 1 & 2</h3>
          <p class="cv__date">2016</p>
          <p class="cv__copy">Central College Nottingham</p>
        </div>
        <div class="cv__section">
          <h3 class="cv__subheading">BTEC Advanced Web Design Level 1 & 2</h3>
          <p class="cv__date">2014 - 2015</p>
          <p class="cv__copy">Central College Nottingham</p>

          <h3 class="cv__subheading">BA (Hons) Graphic Design</h3>
          <p class="cv__date">2004 - 2007</p>
          <p class="cv__copy">University of Lincoln</p>

          <h3 class="cv__subheading">
            BTEC National Diploma in Graphic Design
          </h3>
          <p class="cv__copy">
            Edexcel Keyskills IT <br />
            Communication <br />
            IOLP Level 2 <br />
            OCN Digital Imaging Adobe Photoshop Level 1
          </p>
          <p class="cv__date">2002 - 2004</p>
          <p class="cv__copy">South Nottingham College</p>

          <h3 class="cv__subheading">
            9 GCSE’s A-C (inc. English, Maths and Science)
          </h3>
          <p class="cv__date">1997 - 2002</p>
          <p class="cv__copy">The Wheldon School</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script type="text/javascript">
export default {
  title: "mjccreative | about me"
};
</script>

<style lang="scss" scoped>
@use "../assets/scss/_siteVariables" as *;

.cv {
  //layout styles
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  @media only screen and (min-width: 1000px) {
    .hidden-lg {
      display: none;
    }
  }
  @media only screen and (max-width: 1000px) {
    .hidden-sm {
      display: none;
    }
  }
  &__main {
    @media only screen and (min-width: 1000px) {
      flex: 0 0 70%;
      max-width: 70%;
      width: 70%;
      order: 1;
      padding-right: 30px;
    }
  }
  &__secondary {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    @media only screen and (min-width: 1000px) {
      flex: 0 0 30%;
      max-width: 30%;
      width: 30%;
      order: 2;
      border-left: 1px solid var(--light-grey);
      padding: 0 30px;
      align-content: flex-start;
      .cv__section {
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        margin-bottom: 50px;
      }
    }
  }
  &__section {
    padding-right: 15px;
    padding-left: 15px;
    flex: 0 0 50%;
    max-width: 50%;
    width: 50%;
  }
  &__intro {
    flex-basis: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-bottom: 20px;
  }
  &__experience {
    padding-right: 15px;
    padding-left: 15px;
    margin-bottom: 20px;
  }
  &__education {
    display: flex;
    margin-bottom: 20px;
    .cv__copy {
      margin-top: 0;
    }
    .cv__date {
      margin-bottom: 0;
    }
  }

  //visual styles
  &__skill {
    width: 100%;
    height: 3px;
    background: var(--light-grey);
  }
  &__level {
    height: 3px;
    background: $main-red;
    &--90 {
      width: 90%;
    }
    &--85 {
      width: 85%;
    }
    &--70 {
      width: 70%;
    }
    &--60 {
      width: 60%;
    }
    &--40 {
      width: 40%;
    }
    &--80 {
      width: 80%;
    }
  }
  &__heading {
    color: $main-red;
    font-size: 22px;
    flex-basis: 100%;
  }
  &__subheading {
    font-size: 16px;
    color: var(--darkest-grey);
    flex-basis: 100%;
    margin-bottom: 5px;
    margin-top: 30px;
  }
  &__copy {
    font-size: 14px;
    letter-spacing: 0;
    line-height: 1.5;
    color: var(--darkest-grey);
    flex-basis: 100%;
  }
  &__date {
    font-size: 14px;
    color: $main-red;
    margin-top: 0;
  }
  &__icon {
    width: 60px;
    margin-right: 5px;
    height: 60px;
  }
  &__link {
    text-decoration: none;
    color: var(--accent);
    &:hover {
      text-decoration: underline;
      color: var(--accent);
    }
  }
}
</style>
